export default function Header() {
  return (
    <header style={{ 
      background: "#fff",
      position: "sticky",
      top: 0,
      padding: "12px 16px",
      marginBottom: 12 }}>
      <h2 style={{ margin: 0 }}>TOFU</h2>
      <small style={{ opacity: 0.7 }}>
        Parenting Companion
      </small>
    </header>
  );
}